var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import Validator from 'validatorjs';
import { useState } from 'react';
import { useSearchParams, Link, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Input } from '../../Common/Input/Input';
import CustomButton from '../../Common/Button';
import LightHide from '../../../assets/icons/LightHide.svg';
import LightShow from '../../../assets/icons/LightShow.svg';
import PasswordSuccess from '../../PasswordSuccess';
import axiosInstance from './../../../utils/axios';
import { showToastMessage } from './../../../utils/helpers';
import CircularProgress from '@mui/material/CircularProgress';
var ResetPassword = function () {
    var _a, _b;
    var searchParams = useSearchParams()[0];
    var token = searchParams.get('token');
    var navigate = useNavigate();
    var dispatch = useDispatch();
    var fields = {
        token: token,
        password: '',
        password_confirmation: '',
    };
    var _c = useState(fields), params = _c[0], setParams = _c[1];
    var _d = useState(fields), formErrors = _d[0], setFormErrors = _d[1];
    var _e = useState(false), isLoading = _e[0], setLoading = _e[1];
    var _f = useState(false), apiSuccess = _f[0], setApiSuccess = _f[1];
    var _g = useState(false), eyeOpen = _g[0], seteyeOpen = _g[1];
    var handleChange = function (e) {
        var _a;
        if (e.currentTarget.value.includes(' ')) {
            e.currentTarget.value = e.currentTarget.value.replace(/\s/g, '');
        }
        setParams(__assign(__assign({}, params), (_a = {}, _a[e.target.name] = e.target.value, _a)));
        setFormErrors(fields);
    };
    var submit = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var validation, fieldErrors_1;
        return __generator(this, function (_a) {
            e.preventDefault();
            validation = new Validator(params, {
                password: 'required|min:8|max:14|confirmed',
                password_confirmation: 'required|min:8|max:14',
            });
            if (validation.fails()) {
                fieldErrors_1 = {};
                Object.keys(validation.errors.errors).forEach(function (key) {
                    fieldErrors_1[key] = validation.errors.errors[key][0];
                });
                // console.log(fieldErrors);
                setFormErrors(fieldErrors_1);
                return [2 /*return*/, false];
            }
            // dispatch(resetPassword(params));
            ResetPassword();
            return [2 /*return*/, true];
        });
    }); };
    var ResetPassword = function () {
        setLoading(true);
        axiosInstance
            .post('/reset-password', params)
            .then(function (response) {
            console.log('response:', response);
            setApiSuccess(true);
            setLoading(false);
            showToastMessage(response.data.data.message, 'success');
            navigate('/');
        })
            .catch(function (error) {
            setLoading(false);
            setApiSuccess(false);
            showToastMessage(error.response.data.errors.message, 'error');
            console.log('error:', error);
        });
    };
    return (_jsx(_Fragment, { children: apiSuccess ? (_jsx("div", __assign({ className: 'bg-gray-100 h-screen' }, { children: _jsx("div", __assign({ className: 'w-full m-auto max-w-2xl pt-8' }, { children: _jsx(PasswordSuccess, {}) })) }))) : (_jsx("div", __assign({ className: 'bg-gray-100 h-screen' }, { children: _jsxs("div", __assign({ className: 'w-full m-auto max-w-2xl pt-8' }, { children: [_jsxs("p", __assign({ className: 'text-Sailboat  text-xl  font-nunitoBold flex items-center gap-2 mb-4' }, { children: ["Welcome to", _jsx("span", { children: "Scube PayRoll" })] })), _jsx("p", __assign({ className: 'text-center md:text-left text-xs text-Sailboat mb-8' }, { children: "Please Enter New password" })), _jsxs("form", __assign({ className: 'flex flex-col space-y-4 w-full relative ', onSubmit: submit }, { children: [_jsxs("div", __assign({ className: ' relative' }, { children: [_jsx(Input, { rows: 1, width: 'w-full', disabled: false, readOnly: false, label: 'Enter New Password', name: 'password', value: params === null || params === void 0 ? void 0 : params.password, handleChange: handleChange, type: eyeOpen ? 'text' : 'password', helperText: (formErrors === null || formErrors === void 0 ? void 0 : formErrors.password) ? formErrors === null || formErrors === void 0 ? void 0 : formErrors.password : '', error: ((_a = formErrors === null || formErrors === void 0 ? void 0 : formErrors.password) === null || _a === void 0 ? void 0 : _a.length) > 0 }), eyeOpen ? (_jsx("img", { className: ' absolute right-2 top-4 cursor-pointer', onClick: function () { return seteyeOpen(false); }, src: LightShow, alt: 'eye-closed' })) : (_jsx("img", { className: ' absolute right-2 top-4 cursor-pointer', onClick: function () { return seteyeOpen(true); }, src: LightHide, alt: 'eye-closed' }))] })), _jsx(Input, { rows: 1, width: 'w-full', label: 'Confirm New Password', name: 'password_confirmation', value: params === null || params === void 0 ? void 0 : params.password_confirmation, handleChange: handleChange, type: 'password', helperText: (formErrors === null || formErrors === void 0 ? void 0 : formErrors.password_confirmation)
                                    ? formErrors === null || formErrors === void 0 ? void 0 : formErrors.password_confirmation
                                    : '', error: ((_b = formErrors === null || formErrors === void 0 ? void 0 : formErrors.password_confirmation) === null || _b === void 0 ? void 0 : _b.length) > 0 }), _jsx(CustomButton, __assign({ type: 'submit', variant: 'contained', disabled: isLoading }, { children: _jsxs("span", __assign({ className: 'flex items-center justify-center gap-2' }, { children: [isLoading ? (_jsx(CircularProgress, { size: '2vh', sx: { color: 'black' } })) : (''), "Submit New Password"] })) })), _jsxs("div", __assign({ className: ' flex items-center gap-2 justify-center ' }, { children: [_jsxs("svg", __assign({ width: '20', height: '20', viewBox: '0 0 20 20', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' }, { children: [_jsx("path", { d: 'M3.54102 10.2282L16.041 10.2282', stroke: '#141C4C\n', strokeWidth: '1.5', strokeLinecap: 'round', strokeLinejoin: 'round' }), _jsx("path", { d: 'M8.58203 15.2488L3.54037 10.2288L8.58203 5.20801', stroke: '#141C4C\n', strokeWidth: '1.5', strokeLinecap: 'round', strokeLinejoin: 'round' })] })), _jsx(Link, __assign({ to: '/login', className: ' text-Sailboat text-sm ' }, { children: "Back to Login" }))] }))] }))] })) }))) }));
};
export default ResetPassword;
